
export const environment = {
  production: true,
  apiUrl: 'https://api.africarapture.com/api/',
  attachment_url:'https://api.africarapture.com/',
  Image_url :'https://api.africarapture.com/',
  envName:"PROD"
};
0.